module.exports = __webpack_public_path__ + "img/aside.25474b88.png";